import { render, staticRenderFns } from "./ItemListByWorldTransfer.vue?vue&type=template&id=65318fd4&scoped=true&"
import script from "./ItemListByWorldTransfer.vue?vue&type=script&lang=js&"
export * from "./ItemListByWorldTransfer.vue?vue&type=script&lang=js&"
import style0 from "./ItemListByWorldTransfer.vue?vue&type=style&index=0&id=65318fd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65318fd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VDataTable})
